<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>

       <span v-if="propEnPresentacion.length === 0 && propEliminados.length === 0"
             style="font-size: 11px; color: #74C073; font-weight: 600"
       >No hay tratamientos en esta Categoria </span>


  <div v-else v-for="(init, index) in categoria === 5 ? propEnPresentacion : propEliminados" :key="index">
    <b-card class="text-left" style="border: 0px;">

          <span v-if="!agrupadoPorOD" style="font-size: 11px; color: #79ACCE">
            <em class="dienteTratamiento"></em>
            {{init.nombreTratamiento}}
          </span>
          <span v-else style="font-size: 11px; color: #79ACCE">
            <em class="dienteTratamiento"></em>
            <span v-if="init.diente != 0" >  {{init.diente}} </span>
            <span v-else> {{init.listPadecimientos[0].nombreDiente}} </span>

          </span>
      <table id="tablaInvNoIni" style="width: 100%" >
        <thead>
        <tr >
          <th v-if="!agrupadoPorOD" class="leterSize text-left" style="width: 10%; border-right: #ECECEC 1px solid;">Od´s afectados</th>
          <th v-else class="leterSize text-left" style="width: 12%; border-right: #ECECEC 1px solid;">Tratamiento</th>
          <th class="leterSize bordeTable text-left" >Padecimiento</th>
          <th class="leterSize bordeTable text-center" >Cantidad tratamiento</th>
          <th class="leterSize bordeTable text-center" >No. sesiones</th>
        </tr>
        </thead>
        <b-tbody>
          <b-tr v-for="(pad, ind1) in init.listPadecimientos" :key="'init-'+ind1">
            <b-td v-if="!agrupadoPorOD" class="leterSize text-center" >
              <b-button size="sm" variant="outline-info" pill disabled>
                <span class="leterSize" v-if="pad.numeroDiente != 0 ">{{pad.numeroDiente}}</span>
                <span class="leterSize" v-else>{{pad.nombreDiente}}</span>
              </b-button>
            </b-td>
            <b-td v-else class="leterSize text-center" >
              <b-button size="sm" variant="outline-info" pill disabled class="ml-2 mr-2">
                <span class="leterSize">{{pad.tratamiento}}</span>
              </b-button>
            </b-td>
            <b-td class="leterSize bordeTable">
              {{pad.nombrePadecimiento}}
            </b-td>
            <b-td class="leterSize bordeTable text-center">
              {{pad.cantidad}}
            </b-td>
            <b-td class="leterSize bordeTable text-center">
              {{pad.sesionesRealizadas}}
            </b-td>
          </b-tr>
        </b-tbody>
      </table>
    </b-card>
  </div>
</div>
</template>

<script>

export default {
  name: "EnPresentacionEliminados",
  props: {
    propEnPresentacion: Array,
    propEliminados: Array,
    categoria: Number,
    agrupadoPorOD: Boolean
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
</style>
